class GlobalUtils {
  static globalDivRef: HTMLElement | null = null;

  static sidebarWidth: number = 400;

  static fullScreen: boolean = false;
}

export const setDivRef = (ref: HTMLElement | null) => {
  GlobalUtils.globalDivRef = ref;
};

export const setSidebarWidth = (width: number) => {
  GlobalUtils.sidebarWidth = width;
};

export const setFullScreen = (fullScreen: boolean) => {
  GlobalUtils.fullScreen = fullScreen;
};

export const getInnerWidth = (): number => {
  const value = innerWidth - (innerWidth <= 900 || GlobalUtils.fullScreen ? 0 : GlobalUtils.sidebarWidth);
  return value
};

export const isMobile = () => {
  return window.innerWidth <= 900;
};
